import { createClient } from '@supabase/supabase-js'
import { createDemoClient } from './supabase-demo'

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

export const isSupabaseConfigured = Boolean(
  supabaseUrl &&
    supabaseAnonKey &&
    !supabaseUrl.includes('xxxx') &&
    !supabaseAnonKey.includes('xxx') &&
    !supabaseUrl.includes('demo.supabase.co') &&
    !supabaseAnonKey.includes('.demo'),
)

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        multiTab: true
      },
    })
  : createDemoClient()

export const supabaseProjectHost = (() => {
  if (!isSupabaseConfigured) {
    return 'mode-demo'
  }

  try {
    return new URL(supabaseUrl).host
  } catch {
    return supabaseUrl
  }
})()

if (!isSupabaseConfigured) {
  console.warn(`
╔════════════════════════════════════════════════════════════════╗
║                    🔧 MODE DÉMONSTRATION                       ║
║                                                                ║
║  L'application fonctionne en mode démo car Supabase          ║
║  n'est pas configuré. Les données ne seront pas sauvegardées. ║
║                                                                ║
║  Pour configurer Supabase :                                   ║
║  1. Créez un compte sur https://supabase.com                  ║
║  2. Créez un nouveau projet                                   ║
║  3. Copiez l'URL et la clé anon dans le fichier .env         ║
║  4. Relancez l'application avec: npm run dev                  ║
║                                                                ║
║  Voir CONFIGURATION_RAPIDE.md pour le guide complet           ║
╚════════════════════════════════════════════════════════════════╝
  `)
}
